import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectWorkflowTemplateId } from "@utils/parameter-injector";
import { WorkflowTemplateDetails } from "@idw-types/data/workflow-template-details";

export const getWorkflowTemplateDetailsRequest = async (
    workflowTemplateId: string
): Promise<{ data: WorkflowTemplateDetails, error: any }> => {
    const route = injectWorkflowTemplateId(apiRoutes.serviceConfiguration.data.workflowTemplateWithId, workflowTemplateId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};